import { Component, Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  hideHeaderFooter: boolean = false;

  constructor(private router: Router, private renderer: Renderer2) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const isFlipbook = event.url.includes('read-comic-book') || event.url.includes('read-picture-book');
        this.hideHeaderFooter = isFlipbook;
        this.renderer.removeClass(document.body, 'default-bg');
        this.renderer.removeClass(document.body, 'no-bg');
        this.renderer.addClass(document.body, isFlipbook ? 'no-bg' : 'default-bg');
      }
    });
  }
}
